import { render, staticRenderFns } from "./PillStack.vue?vue&type=template&id=33d4dc2c&"
import script from "./PillStack.vue?vue&type=script&lang=ts&"
export * from "./PillStack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports